import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Season2/s2_01_title.png")